import { AxiosError } from 'axios';
import { createAsyncAction, ActionType, createAction } from 'typesafe-actions';
import {
  PublicAreaData,
  FlightPlanArcrftData,
  FlightPlanArcrftDataList,
  FlightPlanAreaDataList,
  FlightPlanData,
  FlightPlanListRqData,
  FlightPlanPilotDataList,
  PilotSelectData,
  SelectGroupData,
  BasFlightAprovData,
  BasFlightScheduleList,
  weatherData,
  resweatherData,
  FlightUamBufferList,
  FlightUamBufferRq
} from '../models/basisFlightModel';

// 공역 조회
const PUBLIC_AREA_LIST_REQUEST = 'basis/flight/public_area/LIST_REQUEST';
const PUBLIC_AREA_LIST_SUCCESS = 'basis/flight/public_area/LIST_SUCCESS';
const PUBLIC_AREA_LIST_FAILURE = 'basis/flight/public_area/LIST_FAILURE';

// 목록
const FLIGHT_PLAN_LIST_REQUEST = 'basis/flight/plan/list/LIST_REQUEST';
const FLIGHT_PLAN_LIST_SUCCESS = 'basis/flight/plan/list/LIST_SUCCESS';
const FLIGHT_PLAN_LIST_FAILURE = 'basis/flight/plan/list/LIST_FAILURE';

// 상세
const FLIGHT_PLAN_DETAIL_REQUEST = 'basis/flight/plan/detail/DETAIL_REQUEST';
const FLIGHT_PLAN_DETAIL_SUCCESS = 'basis/flight/plan/detail/DETAIL_SUCCESS';
const FLIGHT_PLAN_DETAIL_FAILURE = 'basis/flight/plan/detail/DETAIL_FAILURE';
// 상세 초기화
const FLIGHT_PLAN_DETAIL_INITIAL = 'basis/flight/plan/detail/DETAIL_INIT';
// 생성
const FLIGHT_PLAN_CREATE_REQUEST = 'basis/flight/plan/create/CREATE_REQUEST';
const FLIGHT_PLAN_CREATE_SUCCESS = 'basis/flight/plan/create/CREATE_SUCCESS';
const FLIGHT_PLAN_CREATE_FAILURE = 'basis/flight/plan/create/CREATE_FAILURE';

// 수정
const FLIGHT_PLAN_UPDATE_REQUEST = 'basis/flight/plan/update/UPDATE_REQUEST';
const FLIGHT_PLAN_UPDATE_SUCCESS = 'basis/flight/plan/update/UPDATE_SUCCESS';
const FLIGHT_PLAN_UPDATE_FAILURE = 'basis/flight/plan/update/UPDATE_FAILURE';

// 삭제
const FLIGHT_PLAN_DELETE_REQUEST = 'basis/flight/plan/delete/DELETE_REQUEST';
const FLIGHT_PLAN_DELETE_SUCCESS = 'basis/flight/plan/delete/DELETE_SUCCESS';
const FLIGHT_PLAN_DELETE_FAILURE = 'basis/flight/plan/delete/DELETE_FAILURE';

// 조종사 조회
const FLIGHT_PLAN_PILOT_LIST_REQUEST =
  'basis/flight/plan/pilot_list/PILOT_LIST_REQUEST';
const FLIGHT_PLAN_PILOT_LIST_SUCCESS =
  'basis/flight/plan/pilot_list/PILOT_LIST_SUCCESS';
const FLIGHT_PLAN_PILOT_LIST_FAILURE =
  'basis/flight/plan/pilot_list/PILOT_LIST_FAILURE';

// 조종사 선택
const FLIGHT_PLAN_PILOT_SELECT = 'basis/flight/plan/pilot_list/PILOT_SELECT';

// 기체 조회
const FLIGHT_PLAN_ARCRFT_LIST_REQUEST =
  'basis/flight/plan/arcrft_list/ARCRFT_LIST_REQUEST';
const FLIGHT_PLAN_ARCRFT_LIST_SUCCESS =
  'basis/flight/plan/arcrft_list/ARCRFT_LIST_SUCCESS';
const FLIGHT_PLAN_ARCRFT_LIST_FAILURE =
  'basis/flight/plan/arcrft_list/ARCRFT_LIST_FAILURE';

// 기체 선택
const FLIGHT_PLAN_ARCRFT_SELECT = 'basis/flight/plan/arcrft_list/ARCRFT_SELECT';

// 조종사, 기체 선택 초기화
const PILOT_ARCRFT_SELECT_INITIAL = 'basis/flight/plan/detail/SELECT_INIT';

// 비행 구역 좌표 저장
const AREA_COORDINATE_LIST = 'basis/flight/plan/area/COORDINATE_LIST';

// 비행 구역 상세 저장
const AREA_DETAIL_LIST = 'basis/flight/plan/area/DETAIL_LIST';

// 비행계획서 그룹 선택
const ROUP_SELECT = 'basis/flight/plan/group/select';
// 비행계획서 그룹 선택(목록)
const LIST_GROUP_SELECT = 'basis/flight/plan/group/list/select';
// 비행계획서 그룹 선택(승인)
const APRV_GROUP_SELECT = 'basis/flight/plan/group/aprv/select';

// 조종사, 기체 선택 초기화
const AREA_DETAIL_INITIAL = 'basis/flight/plan/detail/AREA_DETAIL_INIT';

// 버퍼 좌표 가져오기
const AREA_BUFFER_LIST_REQUEST = 'basis/flight/plan/area/BUFFER_LIST_REQUEST';
const AREA_BUFFER_LIST_SUCCESS = 'basis/flight/plan/area/BUFFER_LIST_SUCCESS';
const AREA_BUFFER_LIST_FAILURE = 'basis/flight/plan/area/BUFFER_LIST_FAILURE';
// 날씨
const FLIGHT_WEATHER_REQUEST = 'control/gp/FLIGHT_WEATHER_REQUEST';
const FLIGHT_WEATHER_SUCCESS = 'control/gp/FLIGHT_WEATHER_SUCCESS';
const FLIGHT_WEATHER_FAILURE = 'control/gp/FLIGHT_WEATHER_FAILURE';

// 비행계획서 조회(승인)
const FLIGHT_APRV_LIST_REQUEST =
  'basis/flight/aprv/list/FLIGHT_APRV_LIST_REQUEST';
const FLIGHT_APRV_LIST_SUCCESS =
  'basis/flight/aprv/list/FLIGHT_APRV_LIST_SUCCESS';
const FLIGHT_APRV_LIST_FAILURE =
  'basis/flight/aprv/list/FLIGHT_APRV_LIST_FAILURE';

// 비행계획서 승인/미승인 처리
const FLIGHT_APRV_PROC_REQUEST =
  'basis/flight/aprv/proc/FLIGHT_APRV_PROC_REQUEST';
const FLIGHT_APRV_PROC_SUCCESS =
  'basis/flight/aprv/proc/FLIGHT_APRV_PROC_SUCCESS';
const FLIGHT_APRV_PROC_FAILURE =
  'basis/flight/aprv/proc/FLIGHT_APRV_PROC_FAILURE';

//지도 검색
const FLIGHT_SEARCH_AREA_REQUEST =
  'basis/flight/search/area/FLIGHT_SEARCH_AREA_REQUEST';
const FLIGHT_SEARCH_AREA_SUCCESS =
  'basis/flight/search/area/FLIGHT_SEARCH_AREA_SUCCESS';
const FLIGHT_SEARCH_AREA_FAILURE =
  'basis/flight/search/area/FLIGHT_SEARCH_AREA_FAILURE';

// 비행운항 스케줄
const FLIGHT_SCHEDULE_REQUEST =
  'basis/flight/schedule/list/FLIGHT_SCHEDULE_REQUEST';
const FLIGHT_SCHEDULE_SUCCESS =
  'basis/flight/schedule/list/FLIGHT_SCHEDULE_SUCCESS';
const FLIGHT_SCHEDULE_FAILURE =
  'basis/flight/schedule/list/FLIGHT_SCHEDULE_FAILURE';

// 버퍼 좌표 가져오기
const UAM_BUFFER_LIST_REQUEST = 'basis/flight/adex/BUFFER_LIST_REQUEST';
const UAM_BUFFER_LIST_SUCCESS = 'basis/flight/adex/BUFFER_LIST_SUCCESS';
const UAM_BUFFER_LIST_FAILURE = 'basis/flight/adex/BUFFER_LIST_FAILURE';

export const SEARCH_AREA = createAsyncAction(
  FLIGHT_SEARCH_AREA_REQUEST,
  FLIGHT_SEARCH_AREA_SUCCESS,
  FLIGHT_SEARCH_AREA_FAILURE
)<{ query: string }, string, AxiosError>();

export const PUBLIC_AREA_LIST = createAsyncAction(
  PUBLIC_AREA_LIST_REQUEST,
  PUBLIC_AREA_LIST_SUCCESS,
  PUBLIC_AREA_LIST_FAILURE
)<PublicAreaData, { data: PublicAreaData }, AxiosError>();

// 목록
export const FLIGHT_PLAN_LIST = createAsyncAction(
  FLIGHT_PLAN_LIST_REQUEST,
  FLIGHT_PLAN_LIST_SUCCESS,
  FLIGHT_PLAN_LIST_FAILURE
)<
  FlightPlanListRqData,
  {
    items: [FlightPlanData];
    total: number;
    count: number;
  },
  AxiosError
>();

// 상세
export const FLIGHT_PLAN_DETAIL = createAsyncAction(
  FLIGHT_PLAN_DETAIL_REQUEST,
  FLIGHT_PLAN_DETAIL_SUCCESS,
  FLIGHT_PLAN_DETAIL_FAILURE
)<number, FlightPlanData, AxiosError>();
// 상세 초기화
export const FLIGHT_PLAN_DETAIL_INIT = createAction(
  FLIGHT_PLAN_DETAIL_INITIAL
)();
// 생성
export const FLIGHT_PLAN_CREATE = createAsyncAction(
  FLIGHT_PLAN_CREATE_REQUEST,
  FLIGHT_PLAN_CREATE_SUCCESS,
  FLIGHT_PLAN_CREATE_FAILURE
)<FlightPlanData, string, AxiosError>();

// 수정
export const FLIGHT_PLAN_UPDATE = createAsyncAction(
  FLIGHT_PLAN_UPDATE_REQUEST,
  FLIGHT_PLAN_UPDATE_SUCCESS,
  FLIGHT_PLAN_UPDATE_FAILURE
)<FlightPlanData, string, AxiosError>();

// 삭제
export const FLIGHT_PLAN_DELETE = createAsyncAction(
  FLIGHT_PLAN_DELETE_REQUEST,
  FLIGHT_PLAN_DELETE_SUCCESS,
  FLIGHT_PLAN_DELETE_FAILURE
)<number, string, AxiosError>();

// 조종사 목록
export const FLIGHT_PLAN_PILOT_LIST = createAsyncAction(
  FLIGHT_PLAN_PILOT_LIST_REQUEST,
  FLIGHT_PLAN_PILOT_LIST_SUCCESS,
  FLIGHT_PLAN_PILOT_LIST_FAILURE
)<string, FlightPlanPilotDataList, AxiosError>();

// 조종사 선택
export const PILOT_SELECT = createAction(
  FLIGHT_PLAN_PILOT_SELECT
)<PilotSelectData>();

// 기체 목록
export const FLIGHT_PLAN_ARCRFT_LIST = createAsyncAction(
  FLIGHT_PLAN_ARCRFT_LIST_REQUEST,
  FLIGHT_PLAN_ARCRFT_LIST_SUCCESS,
  FLIGHT_PLAN_ARCRFT_LIST_FAILURE
)<string, FlightPlanArcrftDataList, AxiosError>();

// 조종사 선택
export const ARCRFT_SELECT = createAction(
  FLIGHT_PLAN_ARCRFT_SELECT
)<FlightPlanArcrftData>();

// 조종사, 기체 선택 초기화
export const PILOT_ARCRFT_SELECT_INIT = createAction(
  PILOT_ARCRFT_SELECT_INITIAL
)();

// 비행 구역 좌표 저장 (스텝2 데이터 공유)
export const AREA_COORDINATE_LIST_SAVE =
  createAction(AREA_COORDINATE_LIST)<FlightPlanAreaDataList>();

// 비행 구역 상세 저장
export const AREA_DETAIL_LIST_SAVE =
  createAction(AREA_DETAIL_LIST)<FlightPlanAreaDataList>();

// 비행 계획서 그룹 선택
export const FLIGHT_PLAN_GROUP_SELECT =
  createAction(ROUP_SELECT)<SelectGroupData>();

// 비행 계획서 그룹 선택(목록)
export const FLIGHT_PLAN_LIST_GROUP_SELECT =
  createAction(LIST_GROUP_SELECT)<SelectGroupData>();

// 비행 계획서 그룹 선택(승인)
export const FLIGHT_PLAN_APRV_GROUP_SELECT =
  createAction(APRV_GROUP_SELECT)<SelectGroupData>();

// 비행 구역 상세 값 초기화
export const AREA_DETAIL_INIT = createAction(AREA_DETAIL_INITIAL)();

// 버퍼 좌표 가져오기
export const FLIGHT_PLAN_AREA_BUFFER_LIST = createAsyncAction(
  AREA_BUFFER_LIST_REQUEST,
  AREA_BUFFER_LIST_SUCCESS,
  AREA_BUFFER_LIST_FAILURE
)<FlightPlanAreaDataList, FlightPlanAreaDataList, AxiosError>();

// 비행계획서 조회(승인)
export const FLIGHT_APRV_LIST = createAsyncAction(
  FLIGHT_APRV_LIST_REQUEST,
  FLIGHT_APRV_LIST_SUCCESS,
  FLIGHT_APRV_LIST_FAILURE
)<
  FlightPlanListRqData,
  {
    items: [FlightPlanData];
    total: number;
    count: number;
  },
  AxiosError
>();
// 비행계획서 승인/미승인 처리
export const FLIGHT_APRV_PROC = createAsyncAction(
  FLIGHT_APRV_PROC_REQUEST,
  FLIGHT_APRV_PROC_SUCCESS,
  FLIGHT_APRV_PROC_FAILURE
)<BasFlightAprovData, string, AxiosError>();

export const FLIGHT_SCHEDULE_LIST = createAsyncAction(
  FLIGHT_SCHEDULE_REQUEST,
  FLIGHT_SCHEDULE_SUCCESS,
  FLIGHT_SCHEDULE_FAILURE
)<string, [BasFlightScheduleList], AxiosError>();

//비행구역 설정 날씨 API
export const FlightweatherAction = createAsyncAction(
  FLIGHT_WEATHER_REQUEST,
  FLIGHT_WEATHER_SUCCESS,
  FLIGHT_WEATHER_FAILURE
)<weatherData, resweatherData, AxiosError>();

// UAM 버퍼 좌표 가져오기
export const FLIGHT_UAM_BUFFER_LIST = createAsyncAction(
  UAM_BUFFER_LIST_REQUEST,
  UAM_BUFFER_LIST_SUCCESS,
  UAM_BUFFER_LIST_FAILURE
)<FlightUamBufferRq, FlightUamBufferList[], AxiosError>();

const actions = {
  PUBLIC_AREA_LIST,
  // FLIGHT_PLAN_AREA,
  FLIGHT_PLAN_LIST,
  FLIGHT_PLAN_DETAIL,
  FLIGHT_PLAN_DETAIL_INIT,
  FLIGHT_PLAN_CREATE,
  FLIGHT_PLAN_UPDATE,
  FLIGHT_PLAN_DELETE,
  FLIGHT_PLAN_PILOT_LIST,
  FLIGHT_PLAN_ARCRFT_LIST,
  PILOT_SELECT,
  ARCRFT_SELECT,
  PILOT_ARCRFT_SELECT_INIT,
  AREA_COORDINATE_LIST_SAVE,
  AREA_DETAIL_LIST_SAVE,
  FLIGHT_PLAN_GROUP_SELECT,
  FLIGHT_PLAN_APRV_GROUP_SELECT,
  FLIGHT_PLAN_LIST_GROUP_SELECT,
  FLIGHT_PLAN_AREA_BUFFER_LIST,
  AREA_DETAIL_INIT,
  FLIGHT_APRV_LIST,
  FLIGHT_APRV_PROC,
  SEARCH_AREA,
  FLIGHT_SCHEDULE_LIST,
  FlightweatherAction,
  FLIGHT_UAM_BUFFER_LIST
};

export type FlightAction = ActionType<typeof actions>;
